import { spaces } from "./spacing";

// Paddings
export const p0 = {
  padding: spaces[0]
};

export const p05 = {
  padding: spaces[0.5]
};

export const p1 = {
  padding: spaces[1]
};

export const p2 = {
  padding: spaces[2]
};

export const py05px1 = {
  padding: `${spaces[0.5]} ${spaces[1]}`
};

// Margins

export const my2 = {
  marginTop: spaces[2]
}

// Expanded padding/margin helpers
export const p3 = { padding: spaces[3] };
export const p4 = { padding: spaces[4] };
export const p5 = { padding: spaces[5] };

export const px0 = { paddingLeft: spaces[0], paddingRight: spaces[0] };
export const px05 = { paddingLeft: spaces[0.5], paddingRight: spaces[0.5] };
export const px1 = { paddingLeft: spaces[1], paddingRight: spaces[1] };
export const px2 = { paddingLeft: spaces[2], paddingRight: spaces[2] };

export const py0 = { paddingTop: spaces[0], paddingBottom: spaces[0] };
export const py05 = { paddingTop: spaces[0.5], paddingBottom: spaces[0.5] };
export const py1 = { paddingTop: spaces[1], paddingBottom: spaces[1] };
export const py2 = { paddingTop: spaces[2], paddingBottom: spaces[2] };

export const pt0 = { paddingTop: spaces[0] };
export const pr0 = { paddingRight: spaces[0] };
export const pb0 = { paddingBottom: spaces[0] };
export const pl0 = { paddingLeft: spaces[0] };

export const pt1 = { paddingTop: spaces[1] };
export const pr1 = { paddingRight: spaces[1] };
export const pb1 = { paddingBottom: spaces[1] };
export const pl1 = { paddingLeft: spaces[1] };

// Margins shorthand
export const m0 = { margin: spaces[0] };
export const m1 = { margin: spaces[1] };
export const m2 = { margin: spaces[2] };
export const m3 = { margin: spaces[3] };

export const mx0 = { marginLeft: spaces[0], marginRight: spaces[0] };
export const mx1 = { marginLeft: spaces[1], marginRight: spaces[1] };
export const mx2 = { marginLeft: spaces[2], marginRight: spaces[2] };

export const my0 = { marginTop: spaces[0], marginBottom: spaces[0] };
export const my1 = { marginTop: spaces[1], marginBottom: spaces[1] };
export const my3 = { marginTop: spaces[3], marginBottom: spaces[3] };

export const mt1 = { marginTop: spaces[1] };
export const mr1 = { marginRight: spaces[1] };
export const mb1 = { marginBottom: spaces[1] };
export const ml1 = { marginLeft: spaces[1] };

// Programmatic helpers
type SpacingKey = keyof typeof spaces;

export const padding = (k: SpacingKey) => ({ padding: spaces[k] });
export const paddingX = (k: SpacingKey) => ({ paddingLeft: spaces[k], paddingRight: spaces[k] });
export const paddingY = (k: SpacingKey) => ({ paddingTop: spaces[k], paddingBottom: spaces[k] });
export const paddingT = (k: SpacingKey) => ({ paddingTop: spaces[k] });
export const paddingR = (k: SpacingKey) => ({ paddingRight: spaces[k] });
export const paddingB = (k: SpacingKey) => ({ paddingBottom: spaces[k] });
export const paddingL = (k: SpacingKey) => ({ paddingLeft: spaces[k] });

export const margin = (k: SpacingKey) => ({ margin: spaces[k] });
export const marginX = (k: SpacingKey) => ({ marginLeft: spaces[k], marginRight: spaces[k] });
export const marginY = (k: SpacingKey) => ({ marginTop: spaces[k], marginBottom: spaces[k] });
export const marginT = (k: SpacingKey) => ({ marginTop: spaces[k] });
export const marginR = (k: SpacingKey) => ({ marginRight: spaces[k] });
export const marginB = (k: SpacingKey) => ({ marginBottom: spaces[k] });
export const marginL = (k: SpacingKey) => ({ marginLeft: spaces[k] });

// Utility: combine px and py into padding shorthand
export const paddingXY = (x: SpacingKey, y: SpacingKey) => ({ padding: `${spaces[y]} ${spaces[x]}` });
export const marginXY = (x: SpacingKey, y: SpacingKey) => ({ margin: `${spaces[y]} ${spaces[x]}` });

// Keep exports stable for existing code (no default export needed)